import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_warning",
  "use": "icon-icon_warning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_warning\"><defs><style></style></defs><path d=\"M512 71.68A440.32 440.32 0 1 1 71.68 512 440.73 440.73 0 0 1 512 71.68m0-51.2A491.52 491.52 0 1 0 1003.52 512 491.52 491.52 0 0 0 512 20.48z\" /><path d=\"M459.571 777.011a52.429 52.429 0 1 0 104.858 0 52.429 52.429 0 1 0-104.858 0zM614.4 325.222l-91.546 359.63a11.264 11.264 0 0 1-21.708 0L409.6 325.221a105.882 105.882 0 1 1 204.8 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol